import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import {useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import ButtonDivisionSection from "../../component/ButtonDivisionSection/ButtonDivisionSection";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {css} from "@emotion/css";
import {RouteInfo} from "../../route/RouteHelper";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import TabPanel from "@mui/lab/TabPanel";
import SliderListGlobalInfo from "./SliderListGlobalInfo";
import SliderItemsList from "./SliderItemsList";


export default function SliderDetail() {

    const navigate = useNavigate()

    const {id} = useParams()

    const [tabSelectedValue, setTabSelectedValue] = useState(sliderDetailTabTypes.sliderDetail.id);

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <ButtonDivisionSection>
                    <RaikoBreadcrumb
                        className={css`flex-grow: 1`}
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "اسلایدر",
                                RouteInfo.SliderList.globalUrl
                            ),
                            raikoBreadCrumbItemGenerator(
                                "اسلایدر ها",
                                RouteInfo.SliderList.globalUrl
                            ),
                        ]}/>

                    <ButtonSecondaryRaiko
                        label={"بازگشت"}
                        onClick={_ => {
                            navigate(RouteInfo.SliderList.globalUrl)
                        }}/>
                </ButtonDivisionSection>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`
                      border-color: var(--header-border-bottom-color) !important;
                    `}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                 label={sliderDetailTabTypes.sliderDetail.title}
                                 value={sliderDetailTabTypes.sliderDetail.id}/>
                        </TabList>
                    </Box>
                    <TabPanel value={sliderDetailTabTypes.sliderDetail.id}>
                        <RaikoGridOneColumn>
                            <SliderListGlobalInfo id={id}/>
                            <SliderItemsList id={id}/>
                        </RaikoGridOneColumn>
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}


const sliderDetailTabTypes = {
    sliderDetail: {
        id: "news-detail",
        title: "اطلاعات پایه"
    }, slider: {
        id: "news-thumbnail",
        title: "تصویر شاخص"
    }, seoDetail: {
        id: "seo-detail",
        title: "بهینه سازی موتور جستجو"
    },
}